import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { IpoApiService, ListWrapperResponse } from '@ip-only/front-end-library';
import { catchError, firstValueFrom, map, of } from 'rxjs';
import {
  Group,
  UpdateGroupUserRequest,
} from '../entities/group-users.entities';
import { GroupUserData } from '../entities/user';
import { UserApiPaths } from './user-api.entities';

const GROUPS_BASE_URL_V1 = `${environment.backendBaseUrl}/v1${UserApiPaths.Groups}`;

@Injectable({ providedIn: 'root' })
export class GroupsApiService implements IpoApiService<Group> {
  constructor(private http: HttpClient) {}

  fetchAll() {
    return this.http
      .get<ListWrapperResponse<Group>>(`${GROUPS_BASE_URL_V1}`)
      .pipe(map((response) => response.items));
  }

  fetchSingle(id: string) {
    return this.http.get<Group>(`${GROUPS_BASE_URL_V1}/${id}`);
  }

  fetchGroupUserData(id: string | undefined) {
    if (id) {
      return firstValueFrom(
        this.http
          .get<GroupUserData>(`${GROUPS_BASE_URL_V1}/${id}`)
          .pipe(catchError(() => of(undefined)))
      );
    }
  }

  create(requestBody: { name: string }) {
    return this.http.post<Group>(GROUPS_BASE_URL_V1, requestBody);
  }

  update(id: string, requestBody: UpdateGroupUserRequest) {
    return this.http
      .put<Group>(`${GROUPS_BASE_URL_V1}/${id}`, requestBody)
      .pipe(map((group) => group));
  }

  delete(id: string) {
    return this.http.delete(`${GROUPS_BASE_URL_V1}/${id}`);
  }
}
